import z from 'zod';

export const fileOwnerTypeSchema = z.enum(['group', 'event', 'user', 'document-parser', 'task', 'system']);

export const fileStatusSchema = z.enum([
	'accepted',
	'inReview',
	'pending',
	'declined',
	'expired',
	'expiryWarning',
	'superseded',
]);

export const fileSchema = z
	.object({
		_id: z.string(),
		id: z.string(),
		ownerId: z.string().optional(),
		ownerType: fileOwnerTypeSchema.optional(),
		mimeType: z.string().optional(),
		fileName: z.string().optional(),
		description: z.string().optional(),
		link: z.string().optional(),
		status: fileStatusSchema.optional(),
		statusReason: z.string().optional(),
		reviewReason: z.array(z.string()).optional(),
		flags: z.array(z.string()).optional(),
		externalUrl: z.string().optional(),
		documentId: z.string().optional(),
		validity: z.string().optional(),
		expiryDate: z.coerce.date().optional(),
		bytes: z.number().optional(),
		type: z.string().optional(),
		metadata: z.any().optional(),
		key: z.string().optional(),
		iv: z.string().optional(),
		salt: z.string().optional(),
		archived: z.boolean().optional(),
		archivedAt: z.coerce.date().optional(),
		hasBeenReviewed: z.boolean().default(false),
		reviewAcknowledged: z.boolean().optional(),
		context: z.any().optional(),
		encryptionKey: z.string().optional(),
		createdAt: z.coerce.date(),
		updatedAt: z.coerce.date(),
	})
	.describe('File');
